export enum QuestionnaireBranchingNodeTypes {
  QUESTION_NODE = "questionNode",
  END_NODE = "endNode",
}

export enum QuestionnaireBranchingEdgeTypes {
  JUMP_EDGE = "jumpEdge",
}
